export default __webpack_public_path__ + "static/media/artpark_logo.967f58e5.png";